import React, { useEffect, useState } from "react";
import ReactSelect from "react-select";
import { ModalBody } from "reactstrap";
import axiosInstance from "../../../../redux/api";
import CloudStorage from "../../../../CloudStorage/CloudStorage";

export default function ModelSubCategory({
  parentid,
  subcategory,
  formData,
  setFormData,
  setModalSubCategory,
}) {
  const transformedCategory = {
    value: subcategory?.id || formData?.subcategory_index?.value,
    label: subcategory?.title || formData?.subcategory_index?.label,
  };

  // ✅ Initialize as an empty array instead of ""
  const [subcategorylist, setSubcategorylist] = useState([]);

  const [tempSubCategory, setTempSubCategory] = useState(
    subcategory ? transformedCategory : ""
  );

  useEffect(() => {
    if (!parentid) return;

    axiosInstance
      .get(`category?type=3&parent_id=${parentid}`)
      .then((response) => {
        const list = response?.data?.response;
        setSubcategorylist(Array.isArray(list) ? list : []);
      })
      .catch((error) => {
        console.error("Failed to fetch subcategories:", error);
        setSubcategorylist([]);
      });
  }, [parentid]);

  const handleValues = (options) => {
    setTempSubCategory(options);
  };

  const handleSave = () => {
    if (tempSubCategory) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        subcategory_index: tempSubCategory,
        sub_category_id: tempSubCategory.value,
      }));
    }
    setModalSubCategory((state) => !state);
  };

  return (
    <>
      {/* Close Button */}
      <button
        onClick={() => setModalSubCategory((state) => !state)}
        className="btn close-button"
      >
        <img
          src={`${CloudStorage.cloudurl}/Assets/Images/common/close-icon.svg`}
          alt="close"
        />
      </button>

      {/* Modal Body */}
      <ModalBody>
        <h4>Edit Subcategory</h4>
        <ReactSelect
          options={subcategorylist.map((item) => ({
            value: item.id,
            label: item.title,
          }))}
          placeholder="Select Subcategory"
          value={tempSubCategory}
          onChange={(options) => options && handleValues(options)}
          isClearable
        />
      </ModalBody>

      {/* Footer */}
      <div className="modal-footer mt-3">
        <button className="btn" onClick={handleSave}>
          Save
        </button>
      </div>
    </>
  );
}
